<template>
	<div class="box-shadow" v-if="can_access('deal_approve','view')">
    <vue-element-loading :active="show" spinner="bar-fade-scale" color="#007bce"/>
    <div class="row">
        <div class="col-md-12">
        <div class="invoice-title text-center">
          <h2>Axis Capital Markets Limited</h2><!-- <br><h3 class="">Level 4, Princes Court, 7 Princes Street,London, EC2R 8AQ</h3> -->
          <br><p class="text-right" style="color:red" v-if="row.approved_by">Approved on {{row.approved_at}}</p>
        </div>
        <hr>
        <div class="row">
          <div class="col-md-6">
            <address>
              <strong>Name :</strong>
              {{row.client_name}}<br><br>
              <strong>Address :</strong>
              {{row.address}}{{row.city?', '+row.city:''}}{{row.state?', '+row.state:''}}{{row.country?', '+row.country:''}}{{row.zip?', '+row.zip:''}}<br><br>
              <strong>email :</strong>
              {{row.email}}<br><br>
            </address>
          </div>
          <div class="col-md-6 text-right">
            <address>
              <strong>Order Date :</strong>
              {{row.trade_date}}<br><br>
              <strong>Order Ref :</strong>
              {{row.ticket_number}}<br><br>
              <strong>Customer Ref :</strong>
              {{row.contract_note}}<br><br>
              <strong>Customer No :</strong>
              {{row.account_number}}<br><br>
            </address>
          </div>
        </div>
      </div>
    </div>
    
    <div class="row">
      <div class="col-md-12">
        <div class="text-center">
          <h3 class=""><strong>{{row.type.search(/charges|deposit|withdrawal|fees|fx/i) >= 0?(row.type+' CONFIRMATION'):(row.type=='DIVIDENDS'?'CORPORATE ACTIONS':'CONTRACT NOTE')}}</strong></h3>
          <p v-if="row.type.search(/charges|deposit|withdrawal|fees|fx/i) >= 0">We are writing to confirm receipt of {{row.type=='FX'?'FX':(row.type).toLowerCase()}}.</p>
          <p v-else-if="['AOTC','DEAL','GIVEIN'].indexOf(row.capacity)>=0">We are pleased to confirm that, acting as your agent, the following transaction has been completed. Thank you for using AxCap247.</p>
          <p v-else>We are pleased to confirm that, acting in a matched principal capacity, the following transaction has been completed on your behalf.</p>
        </div>
        <div class="panel panel-default">
          <!-- <div class="panel-heading text-center">
            <h3 class="panel-title"><strong>Transaction Summary</strong></h3>
          </div> -->
          <div class="panel-body">
            <div class="table-responsive">
              <span>** The below three rows are only showing in the approval screen not in the customer's PDF.</span>
              <table class="table table-striped table-hover table-striped table-bordered">
                <tbody>
                  <tr>
                    <td width="50%">Custodian</td>
                    <td>{{row.custodian_name}}</td>
                  </tr>
                  <tr>
                    <td>Capacity</td>
                    <td>{{row.capacity}}</td>
                  </tr>
                  <tr>
                    <td>Counterparty</td>
                    <td>{{row.counterparty_name}}</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
          <div class="panel-body">
            <div class="table-responsive">
              <table class="table table-striped table-hover table-striped table-bordered">
                <tbody v-if="row.type.search(/charges|deposit|withdrawal|fees|dividends|fx/i) >= 0">
									<tr>
										<td style="">Account type</td>
										<td style="" class="text-left">Share Account</td>
									</tr>
									<tr>
										<td style="">Transaction type</td>
										<td style="" class="text-left">{{row.type}}</td>
									</tr>
									<tr>
										<td style="">Transaction date</td>
										<td style="" class="text-left">{{row.trade_date}}</td>
									</tr>
									<tr>
										<td style="">Value date</td>
										<td style="" class="text-left">{{row.trade_date}}</td>
									</tr>
                  <tr v-if="['FX'].indexOf(row.type)>=0">
										<td style="">Currency From</td>
										<td style="" class="text-left">{{row.lse_id}}</td>
									</tr>
                  <tr v-if="['FX'].indexOf(row.type)>=0">
										<td style="">Selling Amount</td>
										<td style="" class="text-left">{{row.fx_currency_symbol}} {{Number(parseFloat(row.total_quantity).toFixed(2)).toLocaleString('ja-JP')}}</td>
									</tr>
									<tr v-if="['FX'].indexOf(row.type)>=0">
										<td style="">Currency To</td>
										<td style="" class="text-left">{{row.currency}}</td>
									</tr>
                  <tr v-else>
										<td style="">Currency</td>
										<td style="" class="text-left">{{row.currency}}</td>
									</tr>
									<tr>
										<td style="">Amount</td>
										<td style="" class="text-left">{{row.trade_currency_symbol}} {{Number(parseFloat(row.total_consideration).toFixed(2)).toLocaleString('ja-JP')}}</td>
									</tr>
                  <tr v-if="['FX'].indexOf(row.type)>=0">
										<td style="">FX Rate</td>
										<td style="" class="text-left">{{Number(parseFloat(row.trade_price).toFixed(6)).toLocaleString('ja-JP')}}</td>
									</tr>
								</tbody>
                <tbody v-else>
                  <tr>
									<td style="" colspan="1">Account type </td>
									<td style="" colspan="3" class="text-left">Share Account</td>
								</tr>
								<tr>
									<td style="" colspan="1">Investment name</td>
									<td style="" colspan="3" class="text-left">{{row.stock.issuer_name}}</td>
								</tr>
								<tr>
									<td colspan="4" style="border:1px solid #fff;"></td>
								</tr>
								<tr>
									<td style="width:25%">Deal Type</td>
									<td style="width:25%" class="text-left">{{["BUY","FOP IN","TRANSFER IN",'GIVE IN','DVP IN'].indexOf(row.type)>=0?"Best Purchase":"Best Sale"}}</td>
									<td style="width:25%">Cost</td>
									<td style="width:25%" class="text-right">{{row.trade_currency_symbol}} {{Number(parseFloat(row.total_quantity*row.trade_price).toFixed(2)).toLocaleString('ja-JP', { minimumFractionDigits:2 })}}</td>
								</tr>
								<tr>
									<td style="width:25%">Deal Date</td>
									<td style="width:25%" class="text-left">{{row.trade_date}}</td>
									<td style="width:25%">Commission</td>
									<td style="width:25%" class="text-right">{{row.trade_currency_symbol}} {{Number(parseFloat(row.commission_value).toFixed(2)).toLocaleString('ja-JP', { minimumFractionDigits:2 })}}</td>
								</tr>
								<tr>
									<td style="width:25%">Deal Time</td>
									<td style="width:25%" class="text-left">{{row.trade_date}}</td>
									<td style="width:25%">Stamp duty</td>
									<td style="width:25%" class="text-right">{{row.trade_currency_symbol}} {{Number(parseFloat(row.stamp_duty_value).toFixed(2)).toLocaleString('ja-JP', { minimumFractionDigits:2 })}}</td>
								</tr>
								<tr>
									<td style="width:25%">Quantity</td>
									<td style="width:25%" class="text-left">{{Number(parseFloat(row.total_quantity).toFixed(2)).toLocaleString('ja-JP', { minimumFractionDigits:2 })}}</td>
									<td style="width:25%">PTM Levy</td>
									<td style="width:25%" class="text-right">{{row.trade_currency_symbol}} {{Number(parseFloat(row.exchange_fee).toFixed(2)).toLocaleString('ja-JP', { minimumFractionDigits:2 })}}</td>
								</tr>
								<tr>
									<td style="width:25%">Price</td>
									<td style="width:25%" class="text-left">{{parseFloat(row.trade_price).toLocaleString('ja-JP', { minimumFractionDigits:6 })}}</td>
									<td style="width:25%">Other fees</td>
									<td style="width:25%" class="text-right">{{row.trade_currency_symbol}} {{((Number(parseFloat(row.fees_value)+parseFloat(row.other_levy_value)+parseFloat(row.other_taxes_value)+parseFloat(row.other_fees_and_charges_value)).toFixed(2)).toLocaleString('ja-JP', { minimumFractionDigits:2 }))}}</td>
								</tr>
								<tr>
									<td style="width:25%">Settlement date</td>
									<td style="width:25%" class="text-left">{{row.settlement_date}}</td>
									<td style="width:25%">Total amount</td>
									<td style="width:25%" class="text-right">{{row.trade_currency_symbol}} {{Number(parseFloat(row.total_consideration).toFixed(2)).toLocaleString('ja-JP', { minimumFractionDigits:2 })}}</td>
								</tr>
                  <!-- foreach ($order->lineItems as $line) or some such thing here -->
                  <!-- <tr>
                    <td>AxCap247 Account Name</td>
                    <td class="text-right">{{row.client_name||'-'}}</td>
                  </tr>
                  <tr>
                    <td>AxCap247 Account Number</td>
                    <td class="text-right">{{row.account_number||'-'}}</td>
                  </tr>
                  <tr>
                    <td>Contract Note</td>
                    <td class="text-right">{{row.contract_note||'-'}}</td>
                  </tr>
                  <tr>
                    <td>Transaction Type</td>
                    <td class="text-right">{{row.type||'-'}}</td>
                  </tr>
                  <tr>
                    <td>Trade Date</td>
                    <td class="text-right">{{row.trade_date||'-'}}</td>
                  </tr>
                  <tr>
                    <td>Settlement Date</td>
                    <td class="text-right">{{row.settlement_date||'-'}}</td>
                  </tr>
                  <tr>
                    <td>Security Description</td>
                    <td class="text-right">{{row.hasOwnProperty('stock')?row.stock.issuer_name:'-'}}</td>
                  </tr>
                  <tr>
                    <td><span v-if="row.type!='FX'">Ticker</span><span v-else>Currency From</span></td>
                    <td class="text-right">{{row.hasOwnProperty('stock')?row.stock.tidm:(row.lse_id||'-')}}</td>
                  </tr>
                  <tr>
                    <td>Exchange Name</td>
                    <td class="text-right">{{row.hasOwnProperty('stock')?row.stock.exchange_name:'-'}}</td>
                  </tr>
                  <tr>
                    <td>ISIN</td>
                    <td class="text-right">{{row.hasOwnProperty('stock')?row.stock.isin:'-'}}</td>
                  </tr>
                  <tr>
                    <td>SEDOL</td>
                    <td class="text-right">{{row.hasOwnProperty('stock')?row.stock.sedol:'-'}}</td>
                  </tr>
                  <tr>
                    <td>CUSIP</td>
                    <td class="text-right">{{row.hasOwnProperty('stock')?row.stock.cusip:'-'}}</td>
                  </tr>
                  <tr>
                    <td>Quantity</td>
                    <td class="text-right">{{row.total_quantity||'-'}}</td>
                  </tr>
                  <tr>
                    <td>Currency</td>
                    <td class="text-right">{{row.currency||'-'}}</td>
                  </tr>
                  <tr>
                    <td>Price</td>
                    <td class="text-right">{{row.trade_price||'-'}}</td>
                  </tr>
                  <tr>
                    <td>Value</td>
                    <td class="text-right">{{row.trade_value||'-'}}</td>
                  </tr> -->
                  <!-- <tr>
                    <td>Exchange Fees(PTM Levy)</td>
                    <td class="text-right">{{row.exchange_fee||'-'}}</td>
                  </tr> -->
                  <!-- <tr>
                    <td>Total Fees &amp; Charges</td>
                    <td class="text-right">{{row.total_other_charges||'-'}}</td>
                  </tr> -->
                  <!-- <tr>
                    <td>Stamp Duty &amp; Taxes</td>
                    <td class="text-right">{{row.stamp_duty_value||'-'}}</td>
                  </tr> -->
                  <!-- <tr>
                    <td>Total Proceeds</td>
                    <td class="text-right">{{row.total_consideration||'-'}}</td>
                  </tr>
                  <tr v-if="row.approved_by">
                    <td>Reference to Quote</td>
                    <td class="text-right">{{row.reference_to_quote||'-'}}</td>
                  </tr> -->
                </tbody>
              </table> 
            </div>
          </div>
          <div>
            <div class="">
                <p class="text-center" v-if="['WITHDRAWAL','BUY','FOP IN','GIVE IN', 'DVP IN'].indexOf(row.type)>=0">The above amount will be debited from your Share Account on {{row.settlement_date}}.<strong>{{row.type=='WITHDRAWAL'?' Transactions maybe subject to bank or international delay.':''}}</strong></p>

                <p class="text-center" v-else-if="['DEPOSIT','SELL','FOP OUT','GIVE UP','DVP OUT'].indexOf(row.type)>=0">The above amount will be credited to your Share Account on {{row.settlement_date}}<strong>{{row.type=='DEPOSIT'?' and will be available once funds have cleared.':''}}</strong></p>

                <p class="text-center" v-else>The above amount will be debited/credited from your Share Account on <strong>{{row.settlement_date}}</strong></p>
              <!--<table class="table" style="padding:0;border:0;">
                <tbody>
                  <tr>
                    <td style="border-top:0;">The above amount of Total Proceeds</td>
                    <td style="border-top:0;" class="text-right"><strong>{{row.currency']}}</strong> <strong>{{row.total_consideration']}}</strong></td>
                  </tr>
                  <tr>
                    <td style="border-top:0;">will be debited/credited from your AxCap247 Account</td>
                    <td style="border-top:0;" class="text-right"><strong>{{row.account_number']}}</strong></td>
                  </tr>
                  <tr>
                    <td style="border-top:0;">on</td>
                    <td style="border-top:0;" class="text-right"><strong>{{row.settlement_date']}}</strong></td>
                  </tr>
                </tbody>
              </table>-->
            </div>

            <p class="text-center">For queries relating to your account and this transaction, please call our Customer Support Team on +44 (0) 20 3026 2689.</p>

           <!--  <p class="text-center">Axis Capital Markets Limited is a company incorporated in England and Wales with the registration number 08133033 and the registered address of Level 4 Princes Court, 7 Princes Street, London, EC2R 8AQ. Axis Capital Markets Limited is authorised and regulated by the Financial Conduct Authority (FRN: 589327)</p> -->
           <p class="text-center">Axis Capital Markets Limited is a company incorporated in England and Wales with registration number 08133033. Registered address at 27 Clements Lane, London, EC4N 7AE. Member of the London Stock Exchange. Authorized and regulated by the Financial Conduct Authority (FRN: 589327)</p>
          </div>
        </div>
        <hr>
        <div class="" style="display:flow-root" v-if="can_access('deal_approve','modify') && !row.approved_by">
          <div class="row form-group float-right col-sm-4" :class="{error: validation.hasError('reference_to_quote')}">
            <label for="reference_to_quote">Reference to Quote</label><span class="message">{{ validation.firstError('reference_to_quote') }}</span>
            <textarea class="form-control" id="reference_to_quote" v-model="reference_to_quote" rows="2"></textarea>
          </div>
          <div class="row form-check float-right text-right col-lg-12" :class="{error: validation.hasError('notify_customer')}">
            <input type="checkbox" class="form-check-input" id="notify_customer" v-model="notify_customer">
            <label class="form-check-label" for="notify_customer">&nbsp;&nbsp;Send Mail To Customer</label><span class="message">{{ validation.firstError('notify_customer') }}</span>
          </div>
          <div :class="{error: validation.hasError('approved')}"><span class="message">{{ validation.firstError('approved') }}</span></div>
          <button type="button" v-on:click="editTrade" :disabled="approved" class="mt-4 btn-lg btn-info float-right">{{notify_customer?'Mail Preview':'Approve'}}</button>
        </div>   
        <div class="" style="display:flow-root" v-else-if="can_access('deal_approve','modify') && file">
          <div class="pull-right">
              <a class="" target="_blank"  :href="get_baseURL()+file"><i class="fa fa-file-pdf-o pdf-icon" aria-hidden="true"></i></a>
          </div>
        </div> 
      </div>
    </div>
    <b-modal ref="notify-customer" :title="'NOTIFY CUSTOMER'" :size="notify_customer?'lg':'sm'" hide-footer @hidden="() => {show=false;confirm_send_email=false;}">
      
      <div class="form-group form-check">
        <input type="checkbox" class="form-check-input" id="notify_customer_checkbox" v-model="notify_customer">
        <label class="form-check-label" for="notify_customer_checkbox">Notify Customer</label>
      </div>
      <div v-if="notify_customer">
        <div class="form-group">
            <label class="col-lg-2 control-label">To</label>
            <div class="col-lg-12">
                <input type="text" placeholder="" :value="row.email" :readonly="true" class="form-control">
            </div>
        </div>
        <div class="form-group">
            <label class="col-lg-2 control-label">Subject</label>
            <div class="col-lg-12">
                <input type="text" placeholder="" v-model="email_subject" class="form-control" :readonly="true">
            </div>
        </div>
        <div class="form-group">
            <label class="col-lg-2 control-label">Message</label>
            <div class="col-lg-12">
              <textarea placeholder="" v-model="email_body" class="form-control" :readonly="true"></textarea>
              <!-- <vue-editor v-model="email_body" :editorToolbar="customToolbar" :readonly="true"></vue-editor> -->
            </div>
        </div>
        <!-- <div class="form-group">
            <label class="col-lg-2 control-label">Attachment(s):</label>
            <div class="col-lg-12" v-if="email_attachments">
                <a class="" v-for="file in email_attachments" :key="file" target="_blank"  :href="get_baseURL()+file"><i class="fa fa-file-pdf-o pdf-icon" aria-hidden="true"></i></a>
            </div>
        </div> -->
      </div>
      <div class="form-group">
        <div class="col-lg-12">
          <button type="button" class="btn btn-lg btn-info pull-right mt-2" @click.prevent="editTrade()">{{(notify_customer?'Send & ':'')+'Approve Deal'}}</button>
        </div>
      </div>
    </b-modal>
	</div>
</template>
<script>
import common from '@/assets/js/common.js';
import SimpleVueValidator from 'simple-vue-validator';
import VueElementLoading from 'vue-element-loading';
import { VueEditor } from "vue2-editor";

const Validator = SimpleVueValidator.Validator;
export default {
  components: {
    VueElementLoading,
    VueEditor
  },
  mixins: [common,SimpleVueValidator.mixin],
  props: ['row'],
  data(){
  	return {
      reference_to_quote: '',
      notify_customer: 0,
      email_subject: '',
      email_body: '',
      customToolbar: [["bold", "italic", "underline"], [{ list: "ordered" }, { list: "bullet" }]],
      confirm_send_email: false,
      approved: false,
      show: false,
      file: '',
  	}
  },
  validators: {
    'reference_to_quote': function(value) {
      return Validator.value(value).required();
    },
    notify_customer: function(value) {
      var row = this.row;
      return Validator.custom(function () {
        if (!row.email && value) {
          return "Email-Id Required";
        }
      });
    }
  },
  created() {
    if(this.row.approved_by){
      let uri = 'get_report?file_prefix=contract_note&filter='+JSON.stringify({filename: this.row.contract_note});
      this.call_axios(uri).then(res => {
        if(Object.keys(res.response.data.result).length){
          this.$nextTick(() => {
            this.file = 'media/pdf/'+res.response.data.result[0].filename;
          })
        }
      });
    }
  },
  methods: {
    async editTrade(){
      this.show = true;
      this.$validate()
      .then(async (success) => {
        if (success && this.row.id && !this.approved) {
          if(!this.confirm_send_email && this.notify_customer){
            this.confirm_send_email = true;
            this.email_subject = "Axcap247 Contract Note - "+this.row.contract_note+(this.row.approved_times?' (amended)':'');

            if(['DEPOSIT','WITHDRAWAL','FX'].indexOf(this.row.type)>=0)
                this.email_body = ('Hello '+this.row.client_name+', We are writing to confirm receipt of '+(this.row.type=='FX'?'FX':(this.row.type))+'. Please, find the attached file. Thank you for using AxCap247.');

            else if(['AOTC', 'DEAL', 'GIVEIN'].indexOf(this.row.capacity)>=0)
                this.email_body = ('Hello '+this.row.client_name+', We are pleased to confirm that, acting as your agent, the following transaction has been completed. Please, find the attached file. Thank you for using AxCap247.');

            else
                this.email_body = ('Hello '+this.row.client_name+', We are pleased to confirm that, acting in a matched principal capacity, the following transaction has been completed on your behalf. Please, find the attached file. Thank you for using AxCap247.');

            this.$refs['notify-customer'].show();
            return;
          }
          this.approved = true;
          const {response} = await this.call_axios('edit_trade', 'post', {id: this.row.id, approve:1, notify_customer: this.notify_customer, reference_to_quote:this.reference_to_quote, email_subject: this.email_subject, email_body: this.email_body});
          this.show = false;
          this.$emit('tradeFormReRender',response);
          this.this.confirm_send_email = false;
        }
        this.show = false;
      });
    }
  }
}
</script>
<style scoped>
.header-bar{
  text-align: center;
  vertical-align: middle !important;
  font-weight: 700;
  color:#fff;
  padding: 10px 0 0 0;
}

.invoice-title h2, .invoice-title h3 {
    display: inline-block;
}

.table > tbody > tr > .no-line {
    border-top: none;
}

.table > thead > tr > .no-line {
    border-bottom: none;
}

.table th, .table td {
    padding: 0.5rem;
}
.form-check-input {
    margin-top: -0.15rem;
}
.error .message{
  color: red;
  padding: 0px 5px;
}
</style>